import { CreditNoteRepository } from "../repositories/CreditNoteRepository";
import {
  CreditNoteOperationResult,
  CreditNoteDataEntity,
} from "../entities/CreditNoteEntity";

/**
 * Create Zoho Credit Note Use Case
 * Creates a new credit note in the database and pushes it to Zoho Books
 * If creditNoteId is provided, updates the existing credit note instead
 */
export class CreateZohoCreditNoteUseCase {
  constructor(private repository: CreditNoteRepository) {}

  async execute(
    creditNoteData: CreditNoteDataEntity,
    pdfUrl?: string,
    creditNoteId?: number
  ): Promise<CreditNoteOperationResult> {
    return await this.repository.createZohoCreditNote(
      creditNoteData,
      pdfUrl,
      creditNoteId
    );
  }
}
